<template>
  <div class="ftable">
    <!-- table-before -->
    <!-- <el-row class="tb">
      <el-row class="fl item">
        <span>共{{ total }}条</span>
        <span>已选：{{choose}}</span>
        <span>|</span>
        <el-button type="danger" class="del">批量删除</el-button>
      </el-row>
      <el-row class="fr ico">
        <span class="iconfont">&#xe65c;</span>
        <span class="iconfont">&#xe615;</span>
        <span class="iconfont">&#xe60a;</span>
      </el-row>
    </el-row> -->

    <el-table
      :data="tableData"
      border
      stripe
      fit
      ref="multipleTable"
      highlight-current-row
      :height="tabheight"
      @row-dblclick="rowDblclick"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-background="rgba(0, 0, 0, 0.3)"
      @selection-change="handleSelectionChange"
    >
      <!-- 是否需要全选， isshow控制-->
      <el-table-column
        v-if="isshow"
        type="selection"
        align="center"
        fixed
      ></el-table-column>


      <el-table-column v-for="item in tableHeader.filter(el => el.prop === 'imgUrl')"
                       :key="item.prop"
                       :label="item.label"
                       :width="item.width"
                       align="center"  
      >
        <template slot-scope="scope">
          <img :src="scope.row.imgUrl" 
               alt=""
               style="width:100px;height:100px" 
          >
        </template>
      </el-table-column>


      <el-table-column
        v-for="(th, key) in tableHeader.filter(el => el.prop !== 'imgUrl')"
        :key="key"
        :prop="th.prop"
        :label="th.label"
        :fixed="th.fixed"
        :width="th.width"
        :min-width="th.minWidth"
        align="center"
      >
      </el-table-column>
      <el-table-column v-if="isOperate" label="操作" align="center">
        <template slot-scope="scope">
          <div class="fx fa fc">
             <el-button v-for="(item,index) in operateList" 
                        :key="index" 
                        :type="item.type"
                        :size="item.size"
                        :disabled="item.name == '退款' && !(scope.row.orderStatus == 1 && scope.row.payType == 0)"
                       @click="handlerOperate(scope.row,item.mark)"
             >{{item.name}}</el-button>
          </div>
        </template>
        </el-table-column>
    </el-table>
    <elMesBox
      :title="'修改'"
      :show.sync="isModify"
      :modifyData="modify"
      @handler="transferData"
    ></elMesBox>
  </div>
</template>

<script>
import elMesBox from "../el_message_box/Index";
export default {
  components: { elMesBox },
  data() {
    return {
      choose: 0,
      isModify: false,
      modify: {},
    };
  },
  // 传入的数据
  props: {
    total: {
      type: Number,
      default: 0,
    },
    tableData: {
      // 表格数据
      type: Array,
      default: function () {
        return [];
      },
    },
    rowDblclick: {
      // 单行点击事件
      type: Function,
      default: (row, event, column) => {
        console.log("default: " + row + "---" + event + "---" + column);
      },
    },
    tableHeader: {
      // 表格头部
      type: Array,
      default: function () {
        return [];
      },
    },
    operateList:{
      type:Array,
      default:function() {
        return [];
      }
    },
    tabheight: {
      type: String,
      default: "100%",
    },
    loading: {
      // 加载等待
      type: Boolean,
      default: false,
    },
    isshow: {
      type: Boolean,
      default: false,
    },
    isOperate: {
      type: Boolean,
      default: true,
    }
  },
  methods: {
    // 点击操作按钮 1--modify 2--delete 3--库存 之后按钮就添加在这里
    handlerOperate(row,mark) {
      mark == 1 && this.handleEdit(row);
      mark == 2 && this.handleDelete(row);
      mark == 3 && this.handleRecive(row);
    },
    handleRecive(row){
      this.$emit("handleRecive", row);
    },
    //点击修改
    handleEdit(row) {
      // this.isModify = true;
      // this.modify = row;
      this.$emit("handlerTable", row);
    },
    //数据传递
    transferData(val) {
      console.log(val);
      this.$emit("handlerTable", val);
    },
    //点击删除
    handleDelete(val) {
      this.$emit("handlerDelete", val);
    },

    handleSelectionChange(val) {
      this.choose = val.length;
    },
  },
};
</script>

<style scoped>
.ftable {
  height: 77%;
}
.modify {
  font-size: 14px;
  padding: 0 10px;
  color: coral;
  cursor: pointer;
}
.oper > div:nth-child(1) {
  border-right: 1px solid #333;
}
.delsingle {
  font-size: 14px;
  color: crimson;
  padding: 0 10px;
  cursor: pointer;
}
.tb {
  height: 65px;
  line-height: 65px;
  background: #f7f7f7;
}
.item > span {
  margin-left: 22px;
}
.item > span:nth-child(3) {
  margin-left: 0;
  padding: 0 22px;
  font-size: 20px;
  color: darkgrey;
}
.del {
  background: #fff;
  color: red;
  padding: 5px 10px;
}
.ico > span {
  margin-right: 10px;
}
.line {
  color: darkgrey;
  padding: 0 10px;
}
</style>
